import React from "react";
import { Grid, Box, Typography, Select, MenuItem, FormControl } from "@mui/material";
import PlayerHeadshot from "src/components/PlayerHeadshot";
import { getTeamExternalId } from "src/utils/matchDetailsUtils";

const MatchHeader = ({ details, status, onStatusChange }) => {
  const getStatusColor = (statusValue) => {
    const s = statusValue?.toLowerCase();
    if (s === "live" || s === "inprogress") return "#00BC6D";
    if (s === "upcoming" || s === "scheduled") return "#FF8423";
    if (s === "finished" || s === "completed") return "#AAAAAA";
    if (s === "cancelled") return "#FF0000";
    return "#1976d2";
  };
  return (
    <Grid container spacing={2} alignItems="center" sx={{ mb: 4 }}>
      <Grid item xs={4}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            ml: 6,
          }}
        >
          <PlayerHeadshot
            row={{ externalRef: getTeamExternalId(details, 'Home') }}
            imageHash={details.HomeTeamName}
          />
          <Typography variant="h3" sx={{ mt: 1, color: "#6A707E" }}>
            {details.HomeTeamName}
          </Typography>

          <Typography variant="h6" sx={{ color: "#6A707E", mt: 5 }}>
            Home
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={4}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="body2"
              sx={{ fontSize: "0.875rem", color: "text.secondary" }}
            >
              {details.Minute || "--"}
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontSize: "0.875rem", color: "text.secondary" }}
            >
              {details.Period || "--"}
            </Typography>
            <Box display="flex" alignItems="center" gap={15}>
              <Typography
                variant="h1"
                sx={{
                  fontWeight: 700,
                  fontSize: "70px",
                  color: "#2465d1",
                }}
              >
                {details.HomeTeamScore}
              </Typography>

              <Typography variant="h3" component="span" sx={{ mx: 1 }} />

              <Typography
                variant="h1"
                sx={{
                  fontWeight: 700,
                  fontSize: "70px",
                  color: "#2465d1",
                }}
              >
                {details.AwayTeamScore}
              </Typography>
            </Box>
            <FormControl sx={{ minWidth: 150 }}>
              <Select
                value={status || "UPCOMING"}
                onChange={(e) => onStatusChange && onStatusChange(e.target.value)}
                size="small"
                sx={{
                  backgroundColor: getStatusColor(status),
                  color: "#fff",
                  borderRadius: "4px",
                  height: "35px",
                  fontWeight: "bold",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .MuiSelect-icon": {
                    color: "#fff",
                  },
                  "&:hover": {
                    backgroundColor: getStatusColor(status),
                  },
                  "&.Mui-focused": {
                    backgroundColor: getStatusColor(status),
                  },
                }}
              >
                <MenuItem value="LIVE">LIVE</MenuItem>
                <MenuItem value="UPCOMING">UPCOMING</MenuItem>
                <MenuItem value="FINISHED">FINISHED</MenuItem>
                <MenuItem value="CANCELLED">CANCELLED</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={4}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            mr: 6,
          }}
        >
          <PlayerHeadshot
            row={{ externalRef: getTeamExternalId(details, 'Away') }}
            imageHash={details.AwayTeamName}
          />
          <Typography variant="h3" sx={{ mt: 1, color: "#6A707E" }}>
            {details.AwayTeamName}
          </Typography>
          <Typography variant="h6" sx={{ color: "#6A707E", mt: 5 }}>
            Away
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default MatchHeader;
